import {Directive, ElementRef, EventEmitter, Output, HostListener, Input} from '@angular/core'

@Directive({
  selector: '[outsideClick]',
})
export class OutsideClickDirective {
  private clickCount: number = 0;
  constructor(private _elementRef: ElementRef) {}

  @Output()
  public outsideClick = new EventEmitter();

  // Useful for bindings to ngIf when first click makes component appear.
  @Input() ignoreFirstClick: boolean = true;

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const insideClick = this._elementRef.nativeElement.contains(targetElement)

    // Don't count confirmation dialogs as 'outside clicks'
    const swalElement = document.querySelector('.swal2-container')
    const swalClick = swalElement && swalElement.contains(targetElement)

    if (!insideClick && !swalClick) {
      this.clickCount++
      if (this.ignoreFirstClick && this.clickCount <= 1) {
        return
      }
      else
        this.outsideClick.emit()
    }
  }
}
